/* eslint-disable jsx-a11y/anchor-is-valid */
import { Component } from "react";

export default class BreadcrumbDropdownToggle extends Component {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();

    this.props.onClick(e);
  }

  render() {
    const { open } = this.props;
    return (
      <a href="" className="breadcrumb-dropdown-toggle" onClick={this.handleClick}>
        {this.props.children}

        <i className={`fa ${!open ? "fa-angle-down" : "fa-angle-up"}`} style={{ fontSize: 18, marginLeft: 7 }} />
      </a>
    );
  }
}
